module.exports = __webpack_public_path__ + "static/media/Screen4_right.5fb34d25.png";